
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { trigger, transition, animate, style, state } from '@angular/animations';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'app-transfer-questions',
    templateUrl: './transfer-questions.component.html',
    styleUrls: ['./transfer-questions.component.scss'],
    animations: [
        trigger('fadeInOutAnim', [
            state('initial', style({opacity: '0'})),
            state('final', style({opacity: '1'})),
            transition('initial=>final', animate('0.5s ease-in-out')),
            transition('final=>initial', animate('0.5s ease-in-out')),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
})
export class TransferQuestionsComponent   implements OnInit {
    public isNewBrand: boolean = environment.isNewBrand

    public openYoutubeDialog = false;

    @Input() public productAreaOrigin: string;
    @Input() public status: string;

    constructor(private store: Store<AppState>) {}

    ngOnInit(): void {
        this.openYoutubeDialog = false;
    }

    public onTalkAdvisorClick() {
        const events = {
            'Product Area Origin': this.productAreaOrigin,
            'Status': this.status,
            'Element': 'Botão Falar com um Assessor',
            'Group': 'Ficou com alguma dúvida',
            'Time Responsável': 'Sky',
        };
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_CLICKED,
                events,
            },
        });
    }

    public onAccordionClick(title: string) {
        const events = {
            'Product Area Origin': this.productAreaOrigin,
            'Status': this.status,
            'Element': `Accordion ${title}`,
            'Group': 'Ficou com alguma dúvida',
            'Text': title,
            'Time Responsável': 'Sky',
        };
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_CLICKED,
                events,
            },
        });
    }

    public openYoutubeDialogReceiver(value: boolean) {
        this.openYoutubeDialog = value;
    }

    public closeYoutubeDialogReceiver(value: boolean) {
        this.openYoutubeDialog = value;
    }

    public openYoutube() {
        this.openYoutubeDialog = true;
    }

}
